import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Trophy, RotateCcw, Sparkles, ArrowRight } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { AIOT_PATH } from "@/lib/aiot";

export const LiveDone = ({ lec, secs, asked, onReplay, onNew }) => {
  const { L } = useLang();
  const stats = [[`${lec?.score ?? 0}/3`, L("checkpoints right", "चेकपॉइंट सही")], [`${Math.max(1, Math.round(secs / 60))} min`, L("learning time", "सीखने का समय")], [asked, L("doubts asked", "पूछे गए सवाल")]];
  return (
    <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} className="rounded-[2rem] bg-[#0B1F3A] text-white p-6 sm:p-10" data-testid="live-done">
      <Trophy className="w-10 h-10 text-[#FBBF24]" />
      <h2 className="mt-3 text-3xl sm:text-4xl font-extrabold">{L("Lecture complete!", "लेक्चर पूरा हुआ!")}</h2>
      <p className="mt-2 text-slate-300" data-testid="live-done-title">{lec?.title}</p>
      <div className="mt-6 grid grid-cols-3 gap-3 max-w-xl">
        {stats.map(([v, l], i) => (
          <div key={i} className="rounded-2xl bg-white/5 border border-white/10 p-4" data-testid={`live-done-stat-${i}`}>
            <div className="text-2xl font-black text-[#5EEAD4]">{v}</div><div className="text-xs text-slate-400 mt-1">{l}</div>
          </div>
        ))}
      </div>
      <div className="mt-7 flex flex-wrap gap-3">
        <button type="button" onClick={onNew} data-testid="live-done-new" className="h-12 px-6 rounded-full bg-[#14B8A6] text-[#0B1F3A] font-black inline-flex items-center gap-2 hover:bg-white transition-colors"><Sparkles className="w-4 h-4" />{L("Learn another topic", "दूसरा टॉपिक सीखें")}</button>
        <button type="button" onClick={onReplay} data-testid="live-done-replay" className="h-12 px-6 rounded-full border border-white/25 font-bold inline-flex items-center gap-2 hover:bg-white/10 transition-colors"><RotateCcw className="w-4 h-4" />{L("Listen again", "फिर से सुनें")}</button>
        <Link to={AIOT_PATH} data-testid="live-done-aiot" className="h-12 px-6 rounded-full border border-white/25 font-bold inline-flex items-center gap-2 hover:bg-white/10 transition-colors">{L("Explore the AIoT Diploma", "AIoT डिप्लोमा देखें")}<ArrowRight className="w-4 h-4" /></Link>
      </div>
    </motion.div>
  );
};
